import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState } from 'preact/hooks';
import { useContext } from './context';
import { DownloadResource } from '../../../types/web-components';
import { TESCookieV2 } from '../shared/cookies';

const renderLink: any = ({ text, url, onClick }) => (
  <div>
    <a
      href={url}
      onClick={onClick}
      className="rdp-cta__primary-btn tds-btn tds-btn--lg tds-btn--block tds-btn--primary-consent"
      rel="nofollow"
    >
      {text}
    </a>
  </div>
);

export const component: DownloadResource = ({ resourceid, children }) => {
  const [isAuthor, setIsAuthor] = useState(false);
  const { userId } = TESCookieV2() || {};

  useContext(({ resource }) => {
    setIsAuthor(Boolean(userId === resource?.authorId));
  });

  // If the author is browsing their own resource, render an edit button that redirects to the editor
  // and the download button
  if (isAuthor) {
    return (
      <div>
        <div className="rdp-cta__hidden-mobile">{renderLink({ text: 'Edit', url: `/uploader/v2/${resourceid}` })}</div>
        {children}         
      </div>
    );
  }

  return children; 
};

register(component, 'tes-download-resource', ['resourceid'], { shadow: false });
